module.exports = __webpack_public_path__ + "static/media/Banner-Option1.6c818654.png";